<template>
  <div class="layout">
    <div class="content">
      <el-container style="height: 90vh;">
        <el-header>
          <navbar></navbar>
        </el-header>
        <el-container>
          <el-aside :width="asideWidth">
            <sidebar></sidebar>
          </el-aside>
          <el-main>
            <app-main></app-main>
          </el-main>
        </el-container>
      </el-container>
    </div>
    <div class="contentMo">
      <van-sticky z-index="100" v-if="title!==''">
        <van-nav-bar
            :title="title"
            left-text="返回"
            left-arrow @click-left="()=>{this.$router.back()}">
        </van-nav-bar>
      </van-sticky>
      <app-main class="app-main"></app-main>
      <van-tabbar route>
        <van-tabbar-item v-if="orderMode" replace to="/oms/order" icon="orders-o">订单</van-tabbar-item>
        <van-tabbar-item v-if="orderMode" replace to="/crm/customer" icon="friends-o">客户</van-tabbar-item>
        <van-tabbar-item replace to="/home" icon="home-o">工作台</van-tabbar-item>

      </van-tabbar>
    </div>
  </div>

</template>

<script>
import {Navbar, Sidebar, AppMain} from './components'
import {mapGetters} from "vuex";

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  data() {
    return {
      orderMode: false,
      finceMode: false,
      wmsMode: false
    }
  },
  created() {
    for (const rolesKey of this.$store.getters.roles) {
      if (rolesKey === "销售经理") {
        this.orderMode = true;
        continue
      }
      if (rolesKey === "会计") {
        this.finceMode = true;
        continue
      }
      if (rolesKey === "仓库") {
        this.wmsMode = true;
      }
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    asideWidth() {
      return this.sidebar.opened ? '64px' : '200px'
    },
    title() {
      return this.$route.meta.title === '首页' ? '' : this.$route.meta.title
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./pc.scss";
@import "./mo.scss";
</style>
